import { ticketApi } from 'sections/LKSection/modules/TicketModule/api'
import { TicketFileUploadDTO } from 'sections/LKSection/modules/TicketModule/types'
import { WEB_LINK_REGEXP } from 'shared/constants/regExp'
import { FileUploadDTO } from 'shared/types/types'

import api from './api'

export enum FileEntityType {
  pickPointOrder = 1,
  user = 2,
  pickPoint = 4,
  ticket = 5,
  passport = 12,
  document = 15, // leaseDocument и btiDocument
}

export type FileUploadRequest = {
  chunkNum: number
  entityType: FileEntityType
  totalSize: number | undefined
  chunk: string
  uuid?: string
  entityId?: number
}

export type FileUploadData = {
  entityType: FileEntityType
  totalSize: number | undefined
  content: string
  entityId?: number
  requestFromPromo?: boolean
}

type Files = {
  totalSize: number
  content: string
}

type FilesUploadData = {
  files: Files[]
  entityType: FileEntityType
  entityId?: number
  isTicket?: boolean
}

export function divideBase64(base64: string): Map<number, string> {
  const partLength = 1_000_000
  const dividedMap = new Map<number, string>()
  const partsCount = Math.ceil(base64.length / partLength)

  for (let i = 0; i < partsCount; i++) {
    dividedMap.set(i, base64.slice(0, partLength))
    base64 = base64.substr(partLength)
  }

  return dividedMap
}

export class FileService {
  filesUpload = async ({
    entityId,
    entityType,
    files,
    isTicket = false,
  }: FilesUploadData): Promise<FileUploadDTO[]> => {
    let savedFiles: Array<FileUploadDTO | TicketFileUploadDTO | null> = []
    const promiseFiles: Promise<FileUploadDTO | TicketFileUploadDTO | null>[] = []

    try {
      for (const { content, totalSize } of files) {
        const res = isTicket
          ? this.ticketFileUpload({
              content,
              totalSize,
              entityType,
            })
          : this.fileUpload({
              entityId,
              content,
              totalSize,
              entityType,
            })

        promiseFiles.push(res)
      }

      savedFiles = await Promise.all(promiseFiles)
    } catch (error) {
      throw new Error((error as Error).message)
    }

    savedFiles = savedFiles.filter((file) => Boolean(file))

    savedFiles = isTicket
      ? (savedFiles as TicketFileUploadDTO[]).map((file) => ({
          imageUrl: file.url,
          uploadedSize: file.uploadedSize,
          chunkNum: file.chunkNum,
          uuid: file.uuid,
        }))
      : savedFiles

    return savedFiles as FileUploadDTO[]
  }

  fileUpload = async ({ content, entityId, entityType, totalSize, requestFromPromo = false }: FileUploadData) => {
    const chunkToData = divideBase64(content)
    let response: FileUploadDTO | null = null

    try {
      for (const [chunkNum, data] of chunkToData.entries()) {
        response = WEB_LINK_REGEXP.test(data)
          ? {
              imageUrl: data,
              uuid: '',
              chunkNum: 0,
              uploadedSize: 0,
            }
          : await api.requests.fileUpload(
              {
                chunk: data,
                totalSize,
                entityId,
                chunkNum,
                entityType,
                /* @ts-expect-error: ложная ошибка */
                uuid: response?.uuid,
              },
              requestFromPromo,
            )
      }

      return response
    } catch (error) {
      throw new Error((error as Error).message)
    }
  }

  ticketFileUpload = async ({ content, entityType, totalSize }: FileUploadData) => {
    const chunkToData = divideBase64(content)
    let response: TicketFileUploadDTO | null = null

    try {
      for (const [chunkNum, data] of chunkToData.entries()) {
        response = await ticketApi.ticketFileUpload({
          chunk: data,
          totalSize,
          chunkNum,
          entityType,
          uuid: response?.uuid,
        })
      }

      return response
    } catch (error) {
      throw new Error((error as Error).message)
    }
  }
}

export const fileService = new FileService()
